import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, LogOut, Globe } from "lucide-react";

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-[#0D0D1A]">
      {/* Top bar */}
      <header className="bg-[#12121F] border-b border-[#252540] px-4 md:px-6 h-14 flex items-center justify-between" data-testid="dashboard-header">
        <div className="flex items-center gap-4">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="dash-logo">
            <LayoutDashboard className="w-5 h-5 text-[#C9A84C]" />
            <span className="text-white font-bold text-sm">MVS Dashboard</span>
          </Link>
          {location.pathname !== "/dashboard" && (
            <Link to="/dashboard" className="text-[#9999B3] hover:text-white text-xs transition-colors">&larr; All Clients</Link>
          )}
        </div>
        <div className="flex items-center gap-4">
          <a href="/" target="_blank" rel="noopener noreferrer" className="text-[#9999B3] hover:text-white text-xs flex items-center gap-1 transition-colors" data-testid="dash-site-link">
            <Globe className="w-3.5 h-3.5" /> View Site
          </a>
          <span className="text-[#6B6B85] text-xs">{user?.name || user?.email}</span>
          <button onClick={handleLogout} className="text-[#9999B3] hover:text-red-400 transition-colors" data-testid="dash-logout">
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </header>
      
      {/* Content */}
      <main className="p-4 md:p-6 max-w-7xl mx-auto">
        <Outlet />
      </main>
    </div>
  );
}
